import EllipsisTooltip from '@/components/EllipsisTooltip';
import React from 'react';
import { Card, Col, Row } from 'kenshin';
import busiTypeKey from '../../_util/busiTypeKey';
import CollapseSearch from './components/CollapseSearch';
import { history } from 'umi';

const ATTENDANCE_APPLY_TYPE = {
  OT: 10, // '加班申请'
  OUT: 11, // '外出申请'
  FORGET: 12, // '忘打卡申请'
  DELAY: 13, // '假期延期申请'
  CANCEL: 14, // '考勤撤销申请'
  VACATION: 15, // '假期申请'
  OT_VACATION: 17, // '加班调休申请'
  CHANGE: 16, // '变更申请' 
  OUT_FEE: 18, // '外出费用申请'
};

let applyTypeStr = {
  [ATTENDANCE_APPLY_TYPE.OT]: '加班申请',
  [ATTENDANCE_APPLY_TYPE.OUT]: '外出申请',
  [ATTENDANCE_APPLY_TYPE.FORGET]: '忘打卡申请',
  [ATTENDANCE_APPLY_TYPE.DELAY]: '假期延期申请',
  [ATTENDANCE_APPLY_TYPE.CANCEL]: '考勤撤销申请',
  [ATTENDANCE_APPLY_TYPE.VACATION]: '假期申请',
  [ATTENDANCE_APPLY_TYPE.OT_VACATION]: '加班调休申请',
  [ATTENDANCE_APPLY_TYPE.CHANGE]: '变更申请',
  [ATTENDANCE_APPLY_TYPE.OUT_FEE]: '外出费用申请',
};

const applyStatusObj = {
  '-1': '待提交',
  0: '审核中',
  1: '审核通过',
  2: '审核拒绝',
  3: '终止流程',
};
/** 表格表头 */
const cloumns = () => {
  const columns = [
    {
      dataIndex: 'attendanceApplyName',
      title: '考勤名称',
      width: 250,
      fixed: 'left',
      // render(userInfo) {
      //   return userInfo?.value;
      // },
    },
    {
      dataIndex: 'applyBusiType',
      title: '申请类型',
      width: 120,
      fixed: 'left',
      render: (val) => applyTypeStr[val],
    },
    {
      dataIndex: 'applyBeginTime',
      title: '申请时间',
      width: 400,
      render(applyBeginTime, row) {
        if (row.vacationList) {
          return row.vacationList.map((item) => (
            <div key={item.vacationSort}>
              <span
                style={{
                  display: 'inline-block',
                  width: '6em',
                  textAlign: 'right',
                }}
              >
                {/* {applyTypeObj[item.vacationId]}： */}
                {item.vacationName}：
              </span>
              {item.applyBeginTime} ~ {item.applyEndTime}
            </div>
          ));
        }
        if (applyBeginTime && row.applyEndTime) {
          return `${applyBeginTime} - ${row.applyEndTime}`;
        }
        // console.log("row,forgetClockApplyDate",row);
        if (row.forgetClockApplyDate) {
          return row.forgetClockApplyDate;
        }
        return '-';
      },
    },
    {
      dataIndex: 'applyStatus',
      title: '流程状态',
      render: (val) => applyStatusObj[val],
    },
  ];
  return columns;
};
/** 搜索数据 */
const searchCloumns = () => {
  const cloumns = [
    {
      name: 'statTime',
      type: 'DatePickerRangePicker',
      props: {
        allowClear: false,
        // disabledDate,
      },
    },
    // {
    //   name: 'applyBusiType',
    //   type: 'Select',
    //   props: {
    //     placeholder: '申请类型',
    //     options: applyTypeList?.map((item) => ({
    //       label: item.name,
    //       value: item.id,
    //     })),
    //     allowClear: true,
    //   },
    // },
    {
      name: 'applyStatus',
      type: 'Select',
      props: {
        placeholder: '流程状态',
        options: [
          { label: '全部', value: -2 },
          { label: '审核中', value: 0 },
          { label: '审核通过', value: 1 },
          { label: '审核拒绝', value: 2 },
          { label: '终止申请', value: 3 },
        ],
      },
    },
  ];
  return cloumns;
};

/** 编辑数据 */
const formCloumns = ({}) => [];

/** 首次保存 */
const firstSave = (values, { process, getAfterStr }) => {};

/** 再次保存 */
const reSave = (values, { process, getAfterStr }) => {};

/** 创建后 */
const created = ({ dispatch, type = 8 }) => {
  console.log('12133created');

  // dispatch({ type: 'attendance/myattendanceApplyList', payload: { type } });
  dispatch({ type: 'attendance/getmyattendancepage' });
};

/** 预览card */
const getCard = (data) => {
  if (Object.keys(data).length == 0) {
    return null;
  }
  return (
    <Card className="process-card-box">
      <Row gutter={[5, 20]}>
        <Col span={20}>
          <span className="label">任务名称：</span>
          {data.taskName}
        </Col>
        <Col span={20}>
          <span className="label">项目：</span>
          {data.projectName}
        </Col>
        <Col span={20}>
          <span className="label">服务类目：</span>
          {data.proServCatgName}
        </Col>
      </Row>
    </Card>
  );
};

const tableOptions = ({ attendance, dispatch, type = 8, tableRef }) => {
  const extra = () => {
    return (
      <CollapseSearch
        onChange={(payload) => {
          tableRef?.reload(payload, true);
          // dispatch({ type: 'performance/getmychangeosapage', payload:{...payload,page:{pageNo:1,pageSize:10}} });
        }}
      />
    );
  };
  console.log('busiType1212121tableOptions');
  return {
    // extra,
    // request: 'performance/getmychangeosapage',
    request: 'attendance/getmyattendancepage',
    data: attendance.myattendanceApplyList,
    columns: cloumns(),
    rowKey: 'attendanceApplyId',
    key: 'osaEdit',
    params: {
      // type,
    },
    // searchCloumns: searchCloumns(),
  };
};

const onSubmit = ({ curData, dispatch }) => {
  return () => {
    const localEmpId = JSON.parse(localStorage.getItem('employeeDTO'))?.empId;
    let curnNodeNumber;
    if (curData.current?.osaMuId == localEmpId) {
      curnNodeNumber = 'OSA_CHANGE_UPDATE_OSA_NODE';
    }
    dispatch({
      type: 'performance/save',
      payload: {
        curOsaSettingData: {
          rows: {
            ...curData.current,
            oldOsaProcessNodeNumber: curData.current.curnNodeNumber,
            curnNodeNumber,
            processApplyMuId: localEmpId,
          },
        },
      },
    });
    // history.push({
    //   pathname: '/performance/selfosa/changosa',
    //   query: {},
    // });

    console.log('curData222', curData);

    history.push({
      pathname: '/attendance/apply/applyDetail',
      query: {
        id: curData.current.attendanceApplyId,
      },
    });
  };
};

const handleToApply = (row = {}, path = 'alllist/addApply') => {
  history.push({
    pathname: '/attendance/' + path,
    query: {
      ...row,
    },
  });
};

export default {
  tableOptions,
  chooseId: 'attendanceApplyId',
  propsName: (data) => data['osaName'],
  propsName: (data) => '考勤',
  onSubmit,
  cloumns,
  searchCloumns,
  formCloumns,
  firstSave,
  reSave,
  onShow: created,
  getCard,
  key: busiTypeKey.ATTENDANCECHANGE,
};
